import { BadgeCheck } from "lucide-react";

/**
 * Small verified-vendor badge — a filled checkmark seal with a tooltip.
 * Rendered inline next to the vendor / seller name on product cards,
 * checkout order summary, order detail, and the exhibitor dashboard.
 * Pass `size` in tailwind classes if you need a smaller/larger seal.
 */
export default function VerifiedBadge({ testid = "verified-badge", size = "h-4 w-4", label = "Verified exhibitor" }) {
  return (
    <span
      data-testid={testid}
      title={label}
      aria-label={label}
      className="inline-flex items-center align-middle text-[#2563EB]"
    >
      <BadgeCheck className={`${size} fill-[#2563EB] text-white`} strokeWidth={2.4} />
    </span>
  );
}
